import { createFileRoute } from "@tanstack/react-router";

import Invoices from "./-components/Invoices";

export const Route = createFileRoute("/_app/_dashboard/subscription/invoices/")(
  {
    component: Invoices,
  }
);
